<template>
	<v-row>
		<v-col cols="9">
			<small class="collab-label">Percentage Completed</small>
			<v-progress-linear :color="completionRateColor" :value="collaboration.completion_rate"></v-progress-linear>
		</v-col>
		<v-col cols="3">
			<p class="text-right">	
				<v-chip :color="statusColor" dark small class="mb-2">{{mwTranslate('status', collaboration.status)}}</v-chip>
			</p>
		</v-col>
	</v-row>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	export default {
		name: "DelegationStats", 
		props: {
			id: {type: String}, 
			title: {type: Boolean, default: true }
		},
		data: () => {
			return {

			}
		},
		components: {
		},
		computed: {
			...Vuex.mapState({
				collaborations: state => state.collaborations || [],
				users: state => state.users || []
			}),
			collaboration(){
				var id = this.id;
				return this.collaborations.find( c => c.id == id )
			}, 
			user(){
				var id = this.collaboration.memmbers[0]
				return this.users.find( u => u.id == id)
			},
			statusColor(){
				if( this.collaboration.status == "in_progress" ){
					return "primary2"
				}
				if( this.collaboration.status == "complete" ){
					return "green"
				}
				return "grey"
			}, 
			completionRateColor(){
				if( this.collaboration.completion_rate > 70 ){
					return "green"
				}
				if( this.collaboration.completion_rate > 30 ){
					return "primary2"
				}
				if( this.collaboration.completion_rate > 30 ){
					return "orange"
				}
				return "grey"
			},		},
		methods: {
		}
		// created(){
			
		// }

	}
</script>